<template>
  <div class="strategy_wrap">
    <navbar_ :Lucency="false" :isBlack="true" :activeIndex="''" />

    <div class="strategy_content">
      <div class="info_box" ref="info_box">
        <div class="title">{{ infoList.name }}</div>

        <div class="introduce">{{ infoList.introduce }}</div>

        <div class="cover" v-if="isCoverShow">
          <img
            :src="infoList.cover"
            :class="{ zoomed: isZoomed }"
            @click="isZoomed = !isZoomed"
          />
        </div>

        <div class="cover_show">
          <div class="show_btn" @click="coverShowClick()">
            {{ isCoverShow ? "收起" : "展开" }}

            <el-icon :size="20">
              <CaretTop v-if="isCoverShow" />
              <CaretBottom v-else />
            </el-icon>
          </div>
        </div>
      </div>

      <div class="page_wrap">
        <el-affix target=".page_wrap" :offset="60">
          <div class="nav_box">
            <div class="nav_list">
              <div
                class="nav_item"
                :class="{ nav_active: index == navIndex }"
                v-for="(item, index) in pageList"
                :key="index"
                @click="navClick(index)"
              >
                {{ item.name }}

                <div class="num" v-if="index == 5 && noticeNums > 0">
                  {{ noticeNums < 100 ? noticeNums : "99+" }}
                </div>
              </div>
            </div>

            <div class="notice_box">
              <div class="notice">
                <div class="switch">
                  <span>只通知收藏</span>

                  <el-switch
                    v-model="collectNotice"
                    size="small"
                    :before-change="noticeBeforeChange"
                    @change="noticeChange"
                  />
                </div>

                <el-tooltip
                  effect="dark"
                  content="收藏策略的止盈止损提示，收藏策略的卖出提示，新策略的买入提示"
                  placement="bottom"
                >
                  <img
                    class="icon"
                    src="@/assets/ai_stock/stub_strategy/icon.png"
                  />
                </el-tooltip>
              </div>

              <!-- <div class="notice">
                <div class="switch">
                  <span>声音提示</span>

                  <el-switch
                    v-model="voiceReminder"
                    size="small"
                    :before-change="noticeBeforeChange"
                    @change="noticeChange"
                  />
                </div>
              </div> -->

              <div class="notice">
                <div class="switch">
                  <span>桌面通知</span>

                  <el-switch
                    v-model="desktopNotice"
                    size="small"
                    :before-change="noticeBeforeChange"
                    @change="noticeChange"
                  />
                </div>

                <el-tooltip effect="dark" placement="bottom">
                  <template #content>
                    <div class="msg_">
                      请保持益学官网正常打开，浏览器通知权限打开，否则将无法进行正常通知。如何打开浏览器通知权限？
                      <span><a href="/zmtzPage" target="_blank">点这里</a></span>
                    </div>
                  </template>

                  <img
                    class="icon"
                    src="@/assets/ai_stock/stub_strategy/icon.png"
                  />
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-affix>

        <div class="page_content">
          <div v-if="navIndex != 0 && !isSubscribe">
            <isunlockPage
              :infoList="infoList"
              :userInfo="userInfo"
              :navIndex="navIndex"
            />
          </div>

          <div v-else>
            <component
              v-if="pageShow && JSON.stringify(infoList) != '{}'"
              :is="pageList[navIndex].comName"
              :key="navIndex"
              :infoList="infoList"
              :userInfo="userInfo"
              :noticeSearchValue="noticeSearchValue"
              :pushStockList="pushStockList"
              @smoothFixedHeight="smoothFixedHeight"
              @skipNotice="skipNotice"
              @getNoticeNums="getNoticeNums"
            ></component>
          </div>
        </div>
      </div>
    </div>

    <footer_ />

    <login_
      v-if="isLoginVisible"
      @closeLogin="isLoginVisible = false"
      @loginSucceed="loginSucceed"
      source="ai"
    />

    <websocket
      v-if="JSON.stringify(infoList) != '{}'"
      :infoList="infoList"
      :collectNotice="collectNotice"
      :desktopNotice="desktopNotice"
      @getNoticeNums="getNoticeNums"
      @pushStockPrice="pushStockPrice"
    />
  </div>
</template>

<script>
import isunlockPage from "@/views/ai_stock/stub_strategy/isunlock/index.vue"; // 未解锁
import yxbxPage from "@/views/ai_stock/stub_strategy/yxbx/index.vue"; // 运行表现
import dqczPage from "@/views/ai_stock/stub_strategy/dqcz/index.vue"; // 当前操作
import sclbPage from "@/views/ai_stock/stub_strategy/sclb/index.vue"; // 收藏列表
import czjlPage from "@/views/ai_stock/stub_strategy/czjl/index.vue"; // 操作记录
import lszjPage from "@/views/ai_stock/stub_strategy/lszj/index.vue"; // 历史战绩
import xxtzPage from "@/views/ai_stock/stub_strategy/xxtz/index.vue"; // 消息通知

import navbar_ from "@/components/navbar/index.vue"; // 顶部导航
import footer_ from "@/components/footer/index.vue"; // 底部
import login_ from "@/components/login/index.vue"; // 登录
import websocket from "@/views/ai_stock/websocket/index.vue"; // 推送

export default {
  components: {
    isunlockPage,
    yxbxPage,
    dqczPage,
    sclbPage,
    czjlPage,
    lszjPage,
    xxtzPage,
    navbar_,
    footer_,
    login_,
    websocket,
  },
  data() {
    return {
      isLoginVisible: false,
      isLogin: localStorage.getItem("yx_isLogin") || false,
      userInfo: JSON.parse(localStorage.getItem("yx_userInfo")) || null,

      isZoomed: false, // info图 是否已放大
      infoList: {},
      isSubscribe: false, // 是否 订阅（有权限）
      saveCoverKeyName: "", // 缩略图 本地存储名字
      isCoverShow: false, // 缩略图 是否显示

      navIndex: this.$route.query.navIndex || 0,
      pageList: [
        {
          name: "运行表现",
          comName: "yxbxPage",
        },
        {
          name: "当前操作",
          comName: "dqczPage",
        },
        {
          name: "收藏列表",
          comName: "sclbPage",
        },
        {
          name: "操作记录",
          comName: "czjlPage",
        },
        {
          name: "历史战绩",
          comName: "lszjPage",
        },
        {
          name: "消息通知",
          comName: "xxtzPage",
        },
      ],
      noticeNums: 0, // 消息未读数量
      noticeSearchValue: "",
      collectNotice: true,
      voiceReminder: true,
      desktopNotice: true,
      pageShow: true, // 页面组件 重置

      pushStockList: [],
    };
  },
  created() {
    this.getStrategyInfo(); // 获取 AI 策略信息
  },
  mounted() {},
  methods: {
    // 获取 AI 策略信息
    getStrategyInfo() {
      let data = {
        code: this.$route.query.code,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/info", data).then((res) => {
        // console.log(res);
        let datas = res.data.data;
        // console.log(datas);

        this.infoList = datas;

        this.saveCoverKeyName = `strategy_cover_${datas.code}_${datas.id}`;
        this.isCoverShow = localStorage.getItem(this.saveCoverKeyName)
          ? false
          : true;

        this.getIsSubscribe(); // 获取 用户是否 订阅（有权限）
      });
    },

    // 获取 用户是否 订阅（有权限）
    getIsSubscribe() {
      if (!this.isLogin) return;

      let data = {
        strategyId: this.infoList.id,
        userNo: this.userInfo.userNo,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/subscribe", data).then((res) => {
        // console.log(res);
        let datas = res.data.data;
        // console.log(datas);

        this.isSubscribe = datas == 1;

        this.getNoticeNums(); // 获取 消息通知-消息未读数量
        this.getNoticeProfile(); // 获取 通知-个性化配置
      });
    },

    // 获取 消息通知-消息未读数量
    getNoticeNums() {
      if (!this.isLogin || !this.isSubscribe) return;

      let data = {
        strategyId: this.infoList.id,
        userNo: this.userInfo.userNo,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/notice-subscript", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data.data;
          // console.log(datas);

          this.noticeNums = datas;
        }
      );
    },

    // 获取 通知-个性化配置
    getNoticeProfile() {
      if (!this.isLogin || !this.isSubscribe) return;

      let data = {
        strategyId: this.infoList.id,
        userNo: this.userInfo.userNo,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/notice-profile", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data?.data;
          // console.log(datas);

          if (datas) {
            this.collectNotice = datas.collectNotice == 1;
            this.voiceReminder = datas.voiceReminder == 1;
            this.desktopNotice = datas.desktopNotice == 1;

            // let msgWay = {
            //   collectNotice: this.collectNotice,
            //   desktopNotice: this.desktopNotice,
            // };

            // localStorage.setItem(
            //   `strategy_notice_${this.infoList.code}_${this.infoList.id}`,
            //   JSON.stringify(msgWay)
            // );
          }
        }
      );
    },

    // 缩略图 显示隐藏 click
    coverShowClick() {
      if (this.isCoverShow) {
        localStorage.setItem(this.saveCoverKeyName, "1");
        this.isCoverShow = false;
        return;
      }

      localStorage.setItem(this.saveCoverKeyName, "");
      this.isCoverShow = true;
    },

    // 二级 tab 点击
    navClick(index) {
      if (this.navIndex != index) {
        if (!this.isLogin) {
          this.isLoginVisible = true;
          return;
        }

        if (this.navIndex == 1 || this.navIndex == 2) {
          this.pushStockList = [];
        }
        if (this.navIndex == 5) {
          this.noticeSearchValue = "";
        }

        this.navIndex = index;

        this.pageShow = false;
        this.$nextTick(() => {
          this.pageShow = true;
        });

        this.smoothFixedHeight(); // 滚动平滑 到 tab
      }
    },

    // 滚动平滑 到 tab
    smoothFixedHeight() {
      let infoBox = this.$refs.info_box;
      if (infoBox) {
        window.scrollTo({
          top: infoBox.offsetHeight, // 目标滚动位置
          behavior: "smooth", // 平滑滚动效果
        });
      }
    },

    // 当前持仓/收藏列表 通知查看详情，跳转 消息通知，并搜索
    skipNotice(text) {
      // console.log(text);

      this.noticeSearchValue = text;

      this.navClick(5);
    },
    // 当前持仓/收藏列表 推送 价格变动
    pushStockPrice(data) {
      if (this.navIndex == 1 || this.navIndex == 2) {
        this.pushStockList = data.stockList;
      }
    },

    // switch 状态改变前的钩子
    noticeBeforeChange() {
      return new Promise((resolve) => {
        if (!this.isLogin) {
          this.isLoginVisible = true;
          resolve(false); // 阻止切换
          return;
        }

        resolve(true); // 允许切换
      });
    },

    // 通知 状态发生改变
    noticeChange() {
      let data = {
        code: this.$route.query.code,
        collectNotice: this.collectNotice,
        voiceReminder: this.voiceReminder,
        desktopNotice: this.desktopNotice,
        strategyId: this.infoList.id,
        userNo: this.userInfo.userNo,
      };

      this.API.CLOUDPost1("quant/api/ai-strategy/notice-profile", data).then(
        (res) => {
          // console.log(res);
        }
      );
    },

    // 登录成功
    loginSucceed() {
      this.isLogin = localStorage.getItem("yx_isLogin") || false;
      this.userInfo = JSON.parse(localStorage.getItem("yx_userInfo")) || null;

      this.isLoginVisible = false;
    },
  },
};
</script>

<style lang="less">
.el-popper {
  .msg_ {
    span {
      border-bottom: 1px solid #fff;
      cursor: pointer;

      a {
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.strategy_wrap {
  padding-top: 60px;

  .strategy_content {
    .info_box {
      background: #28324b;
      color: #fff;
      padding: 40px 6% 24px;

      .title {
        font-weight: bold;
        font-size: 20px;
      }

      .introduce {
        margin-top: 40px;
        font-weight: 400;
        font-size: 14px;
        text-align: justify;
      }

      .cover {
        margin-top: 24px;

        img {
          width: 50%;
          display: block;
          transition: all 0.3s ease;
          cursor: zoom-in;

          &.zoomed {
            width: 100%;
            cursor: zoom-out;
          }
        }
      }

      .cover_show {
        margin-top: 14px;
        display: flex;
        justify-content: center;
        font-size: 14px;

        .show_btn {
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
    }

    .page_wrap {
      background: #050a1a;
      color: #fff;
      padding-top: 50px;

      .el-affix {
        width: auto !important;

        .el-affix--fixed {
          .nav_box {
            background: #050a1a;
            padding: 12px 6%;
          }
        }
      }

      .nav_box {
        font-size: 14px;
        display: flex;
        padding: 0 6%;

        .nav_list {
          display: flex;

          .nav_item {
            margin-left: 20px;
            padding: 4px 10px 5px;
            border-radius: 2px;
            cursor: pointer;
            display: flex;
            align-items: center;

            &:first-child {
              margin-left: 0;
            }

            &.nav_active {
              font-weight: 500;
              background: #28324b;
            }

            .num {
              min-width: 14px;
              max-width: 20px;
              height: 14px;
              line-height: 14px;
              text-align: center;
              margin-left: 4px;
              font-size: 8px;
              background: #ff0714;
              border-radius: 50%;
            }
          }
        }

        .notice_box {
          margin-left: 30px;
          display: flex;

          .notice {
            margin-left: 30px;

            display: flex;
            align-items: center;

            &:first-child {
              margin-left: 0;
            }

            .switch {
              .el-switch {
                height: 16px;
                margin: 0 6px;
                padding-bottom: 2px;
              }
            }

            .icon {
              width: 16px;
              height: 16px;
              cursor: pointer;
            }
          }
        }
      }

      .page_content {
        padding: 0 6% 50px;
      }
    }
  }
}
</style>